/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { BookingListBookingConnectionFragmentDoc } from '../../components/organisms/BookingList/BookingList.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type EntranceBookingsPageBookingFragment = { guid: string, description: string | null, meetingURL: string | null, startsAt: TimeString, endsAt: TimeString, okanekoUser: { nickname: string } | null };

export type EntranceBookingsPageQueryFragment = { currentEntrance: { allBookings: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason: Types.BookingCancelReason | null, summary: string | null, assignedStaff: { displayName: string } } }> } } };

export type EntranceBookingsPageQueryVariables = Exact<{
  startAt: TimeString;
  first: number;
  after?: string | null | undefined;
}>;


export type EntranceBookingsPageQuery = { currentEntrance: { allBookings: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason: Types.BookingCancelReason | null, summary: string | null, assignedStaff: { displayName: string } } }> } } };

export const EntranceBookingsPageBookingFragmentDoc = gql`
    fragment EntranceBookingsPageBooking on Booking {
  guid
  description
  meetingURL
  startsAt
  endsAt
  okanekoUser {
    nickname
  }
}
    `;
export const EntranceBookingsPageQueryFragmentDoc = gql`
    fragment EntranceBookingsPageQuery on Query {
  currentEntrance {
    allBookings(startAt: $startAt, first: $first, after: $after) {
      ...BookingListBookingConnection
    }
  }
}
    ${BookingListBookingConnectionFragmentDoc}`;
export const EntranceBookingsPageDocument = gql`
    query EntranceBookingsPage($startAt: Time!, $first: Uint!, $after: String) {
  ...EntranceBookingsPageQuery
}
    ${EntranceBookingsPageQueryFragmentDoc}`;

/**
 * __useEntranceBookingsPageQuery__
 *
 * To run a query within a Vue component, call `useEntranceBookingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntranceBookingsPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEntranceBookingsPageQuery({
 *   startAt: // value for 'startAt'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useEntranceBookingsPageQuery(variables: EntranceBookingsPageQueryVariables | VueCompositionApi.Ref<EntranceBookingsPageQueryVariables> | ReactiveFunction<EntranceBookingsPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>(EntranceBookingsPageDocument, variables, options);
}
export function useEntranceBookingsPageLazyQuery(variables?: EntranceBookingsPageQueryVariables | VueCompositionApi.Ref<EntranceBookingsPageQueryVariables> | ReactiveFunction<EntranceBookingsPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>(EntranceBookingsPageDocument, variables, options);
}
export type EntranceBookingsPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EntranceBookingsPageQuery, EntranceBookingsPageQueryVariables>;